<p><a href="https://experttabla.ro/termeni-si-conditii/">Termeni și condiții</a> •
  <a href="https://experttabla.ro/gdpr/">GDPR</a> •
  <a href="https://experttabla.ro/politica-de-retur/">Politica de retur</a> •
  <a rel="nofollow" href="https://anpc.ro/">ANPC</a>
</p>

<p>
  SC Expert Tabla SRL •
  CUI: RO 48267810 •
  RC: J24/821/2023 •
  Contact: <a href="tel:0740101510" (click)="trackConversion('Pv7pCN3In6QZELWMoq4q')">0740 101 510</a> / <a
  href="mailto:vanzari@experttabla.ro">vanzari@experttabla.ro</a>
</p>
<div class="floating-menu">
  <div class="floating-menu-bar">
  <a (click)="trackConversion('aL3WCIC47p4aELWMoq4q')" title="Whatsapp" target="_blank" href="https://wa.me/40740101510">
    <img height="22" src="./assets/whatsapp.svg" alt="Whatsapp">
  </a> &nbsp;&nbsp;
  <a (click)="trackConversion('aL3WCIC47p4aELWMoq4q')" title="Telefon" href="tel:0740101510">
    <span class="material-icons">phone</span>
  </a> &nbsp;
  <a (click)="trackConversion('aL3WCIC47p4aELWMoq4q')" title="Email" href="mailto:vanzari@experttabla.ro">
    <span class="material-icons">email</span>
  </a> &nbsp;
  <a href="https://www.facebook.com/experttabla" target="_blank">
    <img height="22" src="./assets/facebook.svg" alt="Facebook">
  </a>
  </div>
</div>


